import { t } from "@web-monorepo/i18n/macro";
import { IconPencil } from "@web-monorepo/dds-icons";
import type { ReactNode } from "react";
import styles from "./SavedToolButton.module.css";

type SavedToolButtonProps = {
  onRowClick: VoidFunction;
  onEditClick: VoidFunction | null;
  children: ReactNode;
  /**
   * The name will get used for automated product events.
   * @see https://www.notion.so/classdojo/Automatic-Product-Events-for-Web-bfc580f10a914c3ba514e5ec20f8ef9e?pvs=4
   */
  "data-name": string;
  buttonText?: string;
};

export default function SavedToolButton({
  "data-name": dataName,
  children,
  onRowClick,
  onEditClick,
  buttonText,
}: SavedToolButtonProps) {
  return (
    <li className={styles.listItem}>
      <button type="button" onClick={onRowClick} className={styles.rowButton} data-name={dataName}>
        {children}
      </button>
      {onEditClick && (
        <button
          type="button"
          data-name="saved_tool_button:render:ideas_pencil_icon"
          className={styles.editButton}
          onClick={(e) => {
            e.stopPropagation();
            onEditClick();
          }}
          aria-label={buttonText ? t`Edit ${{ item: buttonText }}` : t`Edit item`}
        >
          <IconPencil />
        </button>
      )}
    </li>
  );
}
